<mat-dialog-actions cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
	<div class="title"  >
		{{('CONTRACTS.CARD.PRODUCTS.'+ product) |translate}}  :  {{ 'CONTRACTS.CARD.MAKE_PRODUCT_REQUEST' | translate }}
		<app-component-loading [size]="'inline'" [margin]="'0px'" *ngIf="this.formState === 'Submitting'"></app-component-loading>
	</div>
	<mat-icon svgIcon="close-line" mat-dialog-close style="width: 20px;"></mat-icon>
</mat-dialog-actions>
<fieldset [disabled]="formState ==='Submitting'">
	<form [formGroup]="requestForm" class="request-form">
		<mat-form-field class="form-field-cs"  [hideRequiredMarker]="true" style="width: 100% !important;">
			<mat-label>{{ 'MODALS.FIELDS.SERVICE_AMOUNT' | translate }}</mat-label>
			<input matInput type="number" step="0.01" min="0" placeholder="0.00"  [formControl]="total" autocomplete="disabled" >
			@if (total.hasError('required')) {
                <mat-error>{{'VALIDATION.REQUIRED' | translate}}</mat-error>
			}
		</mat-form-field>
        <mat-select 
            class="request-form-select body-l-regular text-extra select-rotate" 
            disableRipple panelClass="nd-select-bank-product" 	
            [placeholder]="'MODALS.FIELDS.SERVICE_TERM' | translate " formControlName="term">
            <mat-select-trigger>
                {{('MODALS.FIELDS.SERVICE_TERM'|translate) +':  '}}{{ term?.value }} 
            </mat-select-trigger>
            <mat-option  class="body-l-regular text-extra request-form-select-option " [value]="null"> 
                    <div>{{'Ввести вручную' | translate }}</div> 
            </mat-option>
            @for (term of  this.termsForRequest;  track term) {
                <mat-option  class="body-l-regular text-extra request-form-select-option " [value]="term"> <div>{{ term }}</div> </mat-option>
            }
        </mat-select>
        <mat-form-field *ngIf="term?.value===null"
            class="form-field-cs"  [hideRequiredMarker]="true" style="width: 100% !important; height: unset !important;">
            <mat-label>{{ 'MODALS.FIELDS.SERVICE_TERM' | translate }}</mat-label>
            <input matInput 
            [formControl]="termManual" autocomplete="disabled" >
            @if (term.hasError('required')) {
            <mat-error>{{'VALIDATION.REQUIRED' | translate}}</mat-error>
            }
        </mat-form-field>
        <div class="request-form-button-block">
            <button mat-dialog-close class="button-icon size-xl secondary-button"  [disabled]="this.formState === 'Submitting'">
                <mat-icon svgIcon="close-line"></mat-icon>
                {{ 'MODALS.BUTTONS.CANCEL'|translate }}
            </button>
            <button (click)="processRequest()"  data-action="processRequest" 
                [disabled]="requestForm.valid !==true || this.formState === 'Submitting' || (!term.value&&!termManual.value)" 	class="button-icon size-xl primary-button">
                <mat-icon svgIcon="checkbox-fill"></mat-icon> 
                    {{('MODALS.BUTTONS.PREPARE'|translate)}}
            </button>
		</div>
	</form>
</fieldset>